import(/* webpackMode: "eager", webpackExports: ["__esModule","default"] */ "/opt/apps/wisprs/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["SubtitleGeneratorSeoSections","SubtitleGeneratorClient"] */ "/opt/apps/wisprs/src/app/tools/subtitle-generator/subtitle-generator-client.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/opt/apps/wisprs/src/components/footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AttributionCapture"] */ "/opt/apps/wisprs/src/components/free-tools/attribution-capture.tsx");
;
import(/* webpackMode: "eager" */ "/opt/apps/wisprs/src/components/free-tools/free-tool-result-state.tsx");
;
import(/* webpackMode: "eager" */ "/opt/apps/wisprs/src/components/free-tools/tracked-tool-link.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Navigation"] */ "/opt/apps/wisprs/src/components/navigation.tsx");
